export default "__VITE_ASSET__D360Zxy2__"